import { Typography } from 'ucl/components/text/Typography';

import { CopyButton, PluInfo, StoreInfo } from 'components/debug-tool';
import { LoyaltyOffer, LoyaltyReward, isLoyaltyOffer } from 'state/loyalty/types';
import { blockContentToPlainText } from 'utils/sanity';
import { findVendorConfig } from 'utils/vendor-config';

interface IIncentiveDebugProps {
  incentive: LoyaltyOffer | LoyaltyReward;
  storePosVendor: string;
}

export const IncentiveDebug: React.FC<IIncentiveDebugProps> = ({ incentive, storePosVendor }) => {
  const incentiveType = isLoyaltyOffer(incentive) ? 'Offer' : 'Reward';
  const incentiveName = isLoyaltyOffer(incentive)
    ? blockContentToPlainText(incentive.name?.localeRaw)
    : incentive.name?.locale;
  const headerText = `${incentiveType}: ${incentiveName}`;
  const loyaltyEngineId = incentive.loyaltyEngineId ?? 'Not Available';
  const vendorConfig = findVendorConfig(incentive?.vendorConfigs, storePosVendor);

  const [benefit] = incentive.incentives ?? [];
  const benefitVendorConfig =
    benefit && 'vendorConfigs' in benefit
      ? findVendorConfig(benefit.vendorConfigs, storePosVendor)
      : null;

  return (
    <>
      <Typography variant="headerOne">{headerText}</Typography>
      <StoreInfo />
      <Typography variant="headerTwo" mb="$2">{`${incentiveType} Plu:`}</Typography>
      {vendorConfig && <PluInfo vendorConfig={vendorConfig} />}
      {benefitVendorConfig && (
        <>
          <Typography variant="headerTwo" mb="$2">
            Benefit Plu:
          </Typography>
          <PluInfo vendorConfig={benefitVendorConfig} />
        </>
      )}
      <CopyButton label={`Engine ID: ${loyaltyEngineId}`} textToCopy={loyaltyEngineId} />
    </>
  );
};
